import React, { useState,useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Slider from "react-slick";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import PrevArrow from '../Components/PrevArrow';
import NextArrow from '../Components/NextArrow';
import { useNavigate, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { loaderStateTrue, loaderStateFalse } from "../../slices/mainSlice";

import {
  getTournamentListApi,
  getPlayerDetailsApi,
} from "../Team/TeamController";

const FixturesPlayersDetails = () => {
	const { t } = useTranslation();
	const dispatch = useDispatch();
	const { playerId } = useParams();

	const [tournamentDetails, setPlayerDetails] = useState({});

	console.log("tournamentDetailstournamentDetailstournamentDetails", tournamentDetails);

	const settings = {
		dots: false,
		arrows: true,
		infinite: true,
		autoplay: true,
		autoplaySpeed: 4000,
		speed: 1000,
		slidesToShow: 1,
		slidesToScroll: 1,
		prevArrow: <PrevArrow />,
		nextArrow: <NextArrow />,
		responsive: [
			{
				breakpoint: 1024,
				settings: { slidesToShow: 1 }
			},
			{
				breakpoint: 640,
				settings: { slidesToShow: 1 }
			}
		]
	};

	const clubHistory = [
		{
			name: "Racing Club de Lens",
			logo: require("../../assets/images/clubs/rcl.png"),
			season: "25/26",
		},
		{
			name: "Stade Brestois 29",
			logo: require("../../assets/images/clubs/sb29.png"),
			season: "24/25",
		},
		{
			name: "Paris Saint-Germain FC",
			logo: require("../../assets/images/clubs/paris.png"),
			season: "23/24",
		},
		{
			name: "Olympique de Marseille",
			logo: require("../../assets/images/clubs/rcl.png"),
			season: "22/23",
		},
		{
			name: "AS Monaco",
			logo: require("../../assets/images/clubs/paris.png"),
			season: "21/22",
		},
		{
			name: "Olympique Lyonnais",
			logo: require("../../assets/images/clubs/sb29.png"),
			season: "20/21",
		},
	];

	useEffect(() => {
		getPlayerDetails();
	}, []);

	const getPlayerDetails = () => {
		try {
			dispatch(loaderStateTrue());
			getPlayerDetailsApi(playerId)
				.then((response) => {
					let responseData = response.data || {};
					setPlayerDetails(responseData);
					dispatch(loaderStateFalse());
				})
				.catch((error) => {
					console.log(error);
					dispatch(loaderStateFalse());
				});
		} catch (error) {
			console.log(error);
			dispatch(loaderStateFalse());
		}
	};


	return (
		<main className="main p-4 relative">
			<div className="flex flex-col">
				<div className="flex flex-wrap items-start gap-y-6 -mx-2">
					<div className="lg:w-4/6 w-full px-2">
						<div className="space-y-5">
							<div className="relative text-white">
								<div className="rounded-xl absolute inset-0 bg-gradient-to-t from-[#3D54AC] to-[#243785] overflow-hidden">
									<div className="absolute -skew-x-[20deg] w-[14vw] top-0 -right-10 bottom-0 bg-[#3D54AC] before:content-[''] before:absolute before:w-2/3 before:top-0 before:left-0 before:bottom-0 before:bg-black/20"></div>
								</div>
								<div className="absolute inset-0 bg-[url('../public/assets/images/clubs/paris.png')] bg-no-repeat bg-[length:200px_200px] bg-center opacity-10"></div>
								<div className="relative h-full">
									<div className="flex max-sm:flex-wrap gap-y-3 justify-between relative">
										<div className="p-5 flex flex-col items-start justify-between space-y-3 md:w-1/2">
											<div className="flex max-sm:flex-wrap items-center gap-3">
												<div>
													<h3 className="font-secondary text-base font-bold uppercase"><span className="text-3xl font-black">10</span> No</h3>
												</div>
											</div>
											<div className="space-y-2">
												<div className="flex items-center gap-x-4">
													<img src="../../assets/images/flags/france.svg" alt="" />

													<span className="px-3 py-1 inline-flex gap-1 items-center text-xs font-semibold text-white rounded-full bg-green-500">
														<img src="../../assets/images/icons/star-fill.svg" alt="Star" width="16" className="icon-white" /> 4.5
													</span>
												</div>

												<div className='font-extrabold uppercase'>
													<h4 className="lg:text-3xl md:text-2xl text-xl">Ousmane</h4>
													<h5 className="lg:text-4xl md:text-3xl text-2xl">Dembélé</h5>
												</div>
											</div>
										</div>
										<div className="lg:-mt-4 text-center max-w-72">
											<img src={require("../../assets/images/club-players/paris.png")} alt="" className="w-full inline-block" />
										</div>

										<button className='btn btn-light !inline-flex items-center gap-1 absolute bottom-4 right-4'>
											<img src="/assets/images/icons/pencil.svg" alt="Edit Player" className='icon-primary-500' />Edit Player
										</button>
									</div>
								</div>
							</div>

							<div className="space-y-8">
								<div className="flex flex-wrap -mx-2 gap-y-4">
									<div className="xs:w-1/2 w-full px-2">
										<div className="relative h-full">
											<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
											</div>
											<div className="px-5 relative space-y-3 h-full">
												<div className="-mx-4 flex flex-wrap justify-between h-full">
													<div className="w-1/2 p-4 space-y-3">
														<h4 className="lg:text-2xl text-xl font-black uppercase">01</h4>
														<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Team goals</h5>
													</div>
													<div className="w-1/2 px-4 flex justify-end items-start">
														<img src={require("../../assets/images/draps-propres.png")} alt="" className="max-w-32" />
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="xs:w-1/2 w-full px-2">
										<div className="relative h-full">
											<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
											</div>
											<div className="px-5 relative space-y-3 h-full">
												<div className="-mx-4 flex flex-wrap justify-between h-full">
													<div className="w-1/2 p-4 space-y-3">
														<h4 className="lg:text-2xl text-xl font-black uppercase">4.47/Match</h4>
														<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Penalty area balls played</h5>
													</div>
													<div className="w-1/2 px-4 flex justify-end items-start">
														<img src={require("../../assets/images/balls-played.png")} alt="" className="max-w-32" />
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="xs:w-1/2 w-full px-2">
										<div className="relative h-full">
											<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
											</div>
											<div className="px-5 relative space-y-3 h-full">
												<div className="-mx-4 flex flex-wrap justify-between h-full">
													<div className="w-1/2 p-4 space-y-3">
														<h4 className="lg:text-2xl text-xl font-black uppercase">16</h4>
														<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Number of chances</h5>
													</div>
													<div className="w-1/2 px-4 flex justify-end items-start">
														<img src={require("../../assets/images/possession-moyenne.png")} alt="" className="max-w-32" />
													</div>
												</div>
											</div>
										</div>
									</div>

									<div className="xs:w-1/2 w-full px-2">
										<div className="relative h-full">
											<div className="rounded-xl absolute inset-0 bg-[#F8F8F8] overflow-hidden">
												<div className="absolute -skew-x-[20deg] w-[10vw] top-0 -right-12 bottom-0 bg-[#B50613] before:content-[''] before:absolute before:w-2/3 before:top-0 before:right-0 before:bottom-0 before:bg-black/10"></div>
											</div>
											<div className="px-5 relative space-y-3 h-full">
												<div className="-mx-4 flex flex-wrap justify-between h-full">
													<div className="w-1/2 p-4 space-y-3">
														<h4 className="lg:text-2xl text-xl font-black uppercase">88</h4>
														<h5 className="lg:text-xl text-lg font-extrabold leading-tight uppercase text-gray-400">Duels won</h5>
													</div>
													<div className="w-1/2 px-4 flex justify-end items-start">
														<img src={require("../../assets/images/draps-propres.png")} alt="" className="max-w-32" />
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>

								<div className="flex flex-wrap -mx-2">
									<div className="xs:w-1/2 w-full px-2">
										<div className="space-y-4">
											<div className="panel rounded-xl border light-border bg-white p-4 space-y-2">
												<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
													<h3 className="xl:text-lg text-base font-extrabold uppercase">Attacking</h3>
												</div>
												<div className="panel-body w-full">
													<table className="table w-full">
														{/* <thead className="border-b light-border">
														<tr>
															<th>Temps</th>
															<th className="text-right">Points</th>
														</tr>
													</thead> */}

														<tbody className="divide-y divide-gray-200 font-secondary font-bold uppercase">
															<tr>
																<td><span className="text-gray-500">Ratio:</span></td>
																<td className="text-right">1 goal/805min</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Penalty area balls played:</span></td>
																<td className="text-right">4.47/Match</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Left feet:</span></td>
																<td className="text-right">3 goals</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Shots on target per match:</span></td>
																<td className="text-right">4.47%</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
											<div className="panel rounded-xl border light-border bg-white p-4 space-y-2">
												<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
													<h3 className="xl:text-lg text-base font-extrabold uppercase">Collective</h3>
												</div>
												<div className="panel-body w-full">
													<table className="table w-full">
														{/* <thead className="border-b light-border">
														<tr>
															<th>Temps</th>
															<th className="text-right">Points</th>
														</tr>
													</thead> */}

														<tbody className="divide-y divide-gray-200 font-secondary font-bold uppercase">
															<tr>
																<td><span className="text-gray-500">Number of chances:</span></td>
																<td className="text-right">16 attempts</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
									<div className="xs:w-1/2 w-full px-2">
										<div className="space-y-4">
											<div className="panel rounded-xl border light-border bg-white p-4 space-y-2">
												<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
													<h3 className="xl:text-lg text-base font-extrabold uppercase">Defensive</h3>
												</div>
												<div className="panel-body w-full">
													<table className="table w-full">
														{/* <thead className="border-b light-border">
														<tr>
															<th>Temps</th>
															<th className="text-right">Points</th>
														</tr>
													</thead> */}

														<tbody className="divide-y divide-gray-200 font-secondary font-bold uppercase">
															<tr>
																<td><span className="text-gray-500">Duels won:</span></td>
																<td className="text-right">88</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Ball recoveries:</span></td>
																<td className="text-right">0.33/Match</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Tackles:</span></td>
																<td className="text-right">6</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
											<div className="panel rounded-xl border light-border bg-white p-4 space-y-2">
												<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
													<h3 className="xl:text-lg text-base font-extrabold uppercase">Discipline</h3>
												</div>
												<div className="panel-body w-full">
													<table className="table w-full">
														{/* <thead className="border-b light-border">
														<tr>
															<th>Temps</th>
															<th className="text-right">Points</th>
														</tr>
													</thead> */}

														<tbody className="divide-y divide-gray-200 font-secondary font-bold uppercase">
															<tr>
																<td><span className="text-gray-500">Fouls committed:</span></td>
																<td className="text-right">17</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Fouls suffered:</span></td>
																<td className="text-right">14</td>
															</tr>
															<tr>
																<td><span className="text-gray-500">Yellow cards:</span></td>
																<td className="text-right">3</td>
															</tr>
														</tbody>
													</table>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div className="lg:w-2/6 w-full px-2 space-y-8 sticky top-20">
						<div className="space-y-5">
							<div className="panel">
								{/* <div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
							<div className="flex justify-between gap-3 w-full">
								<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-left.svg" alt="" /></button>
								<h3 className="xl:text-lg text-base font-extrabold uppercase">Lecture en cours</h3>
								<button className="cursor-pointer"><img src="assets/images/icons/arrow-chevron-right.svg" alt="" /></button>
							</div>
							</div> */}
								<div className="panel-body w-full space-y-8">
									<div className="bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
										<div className="p-5 relative space-y-3">
											<div className="flex justify-between items-center gap-4 w-full">
												<div className="flex-1 font-secondary lg:text-3xl text-2xl uppercase font-black bg-gradient-to-r from-primary-950 to-primary-500 bg-clip-text text-transparent">sÊrie de victoires</div>
												<div className="flex-none pr-5">
													<span className="flex-1 font-secondary lg:text-5xl text-4xl uppercase font-black ">70%</span>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="panel rounded-xl border light-border bg-white p-4 space-y-4">
								<div className="panel-header w-full flex flex-wrap justify-between items-center gap-3">
									<h3 className="xl:text-lg text-base font-extrabold uppercase">{t('club-history')}</h3>
									<button className="btn btn-primary text-nowrap ml-auto">{t('seeAll')}</button>
								</div>
								<div className="panel-body w-full">
									<table className="table w-full">
										<thead className="border-b light-border">
											<tr>
												<th>Clubs</th>
												<th className="text-right">{t('years')}</th>
											</tr>
										</thead>

										<tbody className="divide-y divide-gray-200">
											{clubHistory.map((club, index) => (
												<tr key={index}>
													<td>
														<div className="flex items-center gap-2">
															<span className="flex-none size-10 flex justify-center items-center p-2 rounded-full border light-border bg-white">
																<img src={club.logo} alt={club.name} className="w-5" />
															</span>
															<div className="text-nowrap uppercase">{club.name}</div>
														</div>
													</td>

													<td className="text-nowrap text-right">
														<span className="font-semibold">{club.season}</span>
													</td>
												</tr>
											))}
										</tbody>
									</table>
								</div>
							</div>

							{/* <div className="panel space-y-3">
							<div className="panel-header w-full flex flex-wrap justify-center items-center gap-3">
							<div className="flex justify-center gap-3 w-full">
								<h3 className="xl:text-lg text-base font-extrabold uppercase">Meilleurs joueurs</h3>
							</div>
							</div>
							<div className="panel-body w-full space-y-4 [&_.slick-arrow]:-top-7 [&_.slick-arrow]:z-10 before:[&_.slick-arrow]:hidden [&_.slick-prev]:left-0 [&_.slick-next]:right-0 ">
							<Slider {...settings}>
								<div className="pt-5 bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
									<div className="px-5 relative space-y-3">
									<div className="flex justify-between items-start gap-4 w-full">
										<h4 className="lg:text-2xl text-lg font-black uppercase py-5">Kamory Doumbia</h4>
										<div className="flex-none w-2/3 -mt-4">
										<img src={require("../../assets/images/club-players/kamory-doumbia.png")} alt="" className="max-w-full" />
										</div>
									</div>
									</div>
								</div>
								<div className="pt-5 bg-[url('../public/assets/images/curve-box.svg')] bg-[length:100%_auto] bg-no-repeat relative before:content-[''] before:absolute before:top-[6vw] before:left-0 before:bottom-0 before:right-0 before:bg-[#F8F8F8] before:rounded-b-lg">
								<div className="px-5 relative space-y-3">
									<div className="flex justify-between items-start gap-4 w-full">
									<h4 className="lg:text-2xl text-lg font-black uppercase py-5">JulienLe Cardinal</h4>
									<div className="flex-none w-2/3 -mt-4">
										<img src={require("../../assets/images/club-players/julienLe-cardinal.png")} alt="" className="max-w-full" />
									</div>
									</div>
								</div>
								</div>
							</Slider>
							</div>
						</div> */}
						</div>
					</div>
				</div>
			</div>
		</main>
	);
};

export default FixturesPlayersDetails;
